/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { BaseBlockContent } from "src/components/Block/styles";

export const StyledColorBlockContent = styled(BaseBlockContent)<{ color: string }>`
  width: 100%;
  background-color: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const ColorPicker = styled.input`
  border: 1px solid #000000;
  background-color: transparent;
  height: 30px;
  width: 30px;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 2px;
  padding-bottom: 2px;
`;
